import { render, staticRenderFns } from "./TemplateConfiguration.vue?vue&type=template&id=8d715c94&"
import script from "./TemplateConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TemplateConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports